export const UsageDatapoints = {
    recentFileCardClick: {
        datapoint: {
            name: 'GroupFilesHubRecentFilesCardDefaultActionClick',
        },
    },
};

export const Datapoints = {
    getFileItemsFromCacheAction: {
        datapoint: {
            name: 'GroupFilesHubGetFileItemsFromCacheActionDP',
        },
    },
    getFileItemsRefreshAction: {
        datapoint: {
            name: 'GroupFilesHubGetFileItemsRefreshActionDP',
        },
    },
    PrefetchFilePreviewInformationAction: {
        datapoint: {
            name: 'GroupFilesHubPrefetchFilePreviewInformationActionDP',
        },
    },
    getSharePointTextFileContentAction: {
        datapoint: {
            name: 'GroupFilesHubGetSharePointTextFileContentActionDP',
        },
    },
    pollGroupSiteCreation: {
        datapoint: {
            name: 'GroupFilesHubPollGroupSiteCreationDP',
        },
    },
    ensureGroupSiteCreation: {
        datapoint: {
            name: 'GroupFilesHubEnsureGroupSiteCreationDP',
        },
    },
    previewSharePointFileInNewSxS: {
        datapoint: {
            name: 'GroupFilesHubPreviewSharePointFileInNewSxSDP',
        },
    },
    editWacFileAction: {
        datapoint: {
            name: 'GroupFilesHubEditWacFileActionDP',
        },
    },
    getAuthorizedFilePreviewUrl: {
        datapoint: {
            name: 'GroupFilesHubGetAuthorizedFilePreviewUrlDP',
            // This is temporary for investigating SharePoint file preview reliability.
            // Should be removed as outlined in this work item
            // https://olsapps.visualstudio.com/GroupsVSO/_queries/edit/130004/?triage=true
            options: {
                isCore: true,
            },
        },
    },
};
